import { render, staticRenderFns } from "./wdzhList.vue?vue&type=template&id=71cdcbc7&scoped=true&"
import script from "./wdzhList.vue?vue&type=script&lang=js&"
export * from "./wdzhList.vue?vue&type=script&lang=js&"
import style0 from "./wdzhList.vue?vue&type=style&index=0&id=71cdcbc7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cdcbc7",
  null
  
)

export default component.exports